// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".d260bb12e403fd641f3f9e757d7b4526969e6b19.chunk.bundle.js";
};